import topics from "./topics"
import user from "./user"
import admin from "./admin"
import adminUsers from "./adminUsers"
import documents from "./documents"
import documentsGrid from "./documentsGrid"

/** Komponens-csoportonként külön fájlban gyűjtött UI szövegek: [namespace, key, en, hu, de, fr] */
const CATALOG_ROWS = [...topics, ...user, ...admin, ...adminUsers, ...documents, ...documentsGrid]

export default CATALOG_ROWS
